import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { SubSink } from 'subsink';

import { KeepAliveDialogComponent } from './keep-alive-dialog/keep-alive-dialog.component';

@Injectable()
export class KeepAliveService {
  private subs = new SubSink();

  private timeoutMils = environment.timeoutMinutes * 60 * 1000;
  private lastSucess: Date;

  private timer;

  constructor(public dialog: MatDialog, private http: HttpClient) {}

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(KeepAliveDialogComponent, {
      width: '500px',
      data: null
    });

    this.subs.add(
      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed', result);

        if (result == 'refresh') {
          this.keepAlive();
        }
      })
    );
  }

  private keepAlive() {
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');

    this.subs.add(
      this.http
        .get(environment.loginURL, { headers: headers, responseType: 'json' })
        .subscribe(value => console.log(value))
    );
  }

  stop() {
    if (this.timer) clearTimeout(this.timer);
  }

  recordSucess() {
    this.lastSucess = new Date();
    // console.log("Success at ",this.lastSucess);

    if (this.timer) clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      console.log('Session is about to timeout');
      this.openDialog();
      //Display dialog and ask to refresh session?
    }, this.timeoutMils);
  }
}
